module.exports = __webpack_public_path__ + "static/media/image4.07f292fa.png";